import React from 'react';
import '../App.css';
import { Button } from './Button';
import './HeroSection.css';

function HeroSection() {
    return (
        <div className='hero-container'>
            <video src="/videos/video-2.mp4" autoPlay loop muted />
            <h1>I DEVELOP WEB APPS </h1>
            <p>To Help Small Businesses Connect Globally</p>
            <div className="hero-btns">
                <Button 
                    className='btns' 
                    buttonStyle='btn--outline'
                    buttonSize='btn--large'
                > 
                CONTACT ME
                </Button>
                <a href="" targer="_blank">
                <Button 
                    className='btns' 
                    buttonStyle='btn--primary'
                    buttonSize='btn--large'
                    
                > 
                VIEW MY CV <i className='far fa-play-circle' />
                </Button>
               </a>
            </div>
        </div>
    )
}

export default HeroSection